// src/AddTopicForm.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDropzone } from "react-dropzone";
import { SlCloudUpload } from "react-icons/sl";

const AddTopicForm = () => {
  const [title, setTitle] = useState("");
  const [overview, setOverview] = useState("");
  const [audio, setAudio] = useState(null);
  const [notes, setNotes] = useState(null);
  const [video, setVideo] = useState(null);

  const onDropAudio = (acceptedFiles) => {
    setAudio(acceptedFiles[0]);
  };

  const onDropNotes = (acceptedFiles) => {
    setNotes(acceptedFiles[0]);
  };

  const onDropVideo = (acceptedFiles) => {
    setVideo(acceptedFiles[0]);
  };

  const { getRootProps: getRootPropsAudio, getInputProps: getInputPropsAudio } =
    useDropzone({ onDrop: onDropAudio });
  const { getRootProps: getRootPropsNotes, getInputProps: getInputPropsNotes } =
    useDropzone({ onDrop: onDropNotes });
  const { getRootProps: getRootPropsVideo, getInputProps: getInputPropsVideo } =
    useDropzone({ onDrop: onDropVideo });

  return (
    <div className="bg-white rounded-lg shadow-lg m-4 h-auto">
      <div className="container mx-auto px-8 py-8">
        <h1 className="text-[20px] text-[#400167] font-bold mb-7 font-satoshi">
          Add Topic
        </h1>
        <div className="mb-6">
          <label
            className="block text-[#400167] text-[16px] font-semibold mb-2 font-satoshi"
            htmlFor="title"
          >
            Topic Title
          </label>
          <input
            id="title"
            type="text"
            placeholder="Write course title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="shadow appearance-none border border-[#9E9E9E] rounded w-[683.89px] py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div className="mb-14">
          <label
            className="block text-[#400167] text-[16px] font-semibold mb-2 font-satoshi"
            htmlFor="overview"
          >
            Topic Overview
          </label>
          <ReactQuill
            id="overview"
            theme="snow"
            value={overview}
            onChange={setOverview}
            className="h-40 w-[684px]"
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-[#400167] text-[16px] font-semibold mb-2 font-satoshi"
            htmlFor="audio"
          >
            Upload Audio
          </label>
          <div
            {...getRootPropsAudio({
              className:
                "border-solid border border-[#400167] rounded py-4 px-4 text-center cursor-pointer w-[683.89px]",
            })}
          >
            <input {...getInputPropsAudio()} />
            {audio ? <p>{audio.name}</p> : <p>Click to upload</p>}
          </div>
        </div>
        <div className="mb-4">
          <label
            className="block text-[#400167] text-[16px] font-semibold mb-2 font-satoshi"
            htmlFor="notes"
          >
            Upload Notes
          </label>
          <div
            {...getRootPropsNotes({
              className:
                "border-solid border border-[#400167] rounded py-4 px-4 text-center cursor-pointer w-[683.89px]",
            })}
          >
            <input {...getInputPropsNotes()} />
            {notes ? <p>{notes.name}</p> : <p>Click to upload</p>}
          </div>
        </div>
        <div className="mb-4">
          <label
            className="block text-[#400167] text-[16px] font-semibold mb-2 font-satoshi"
            htmlFor="video"
          >
            Upload Video
          </label>
          <div
            {...getRootPropsVideo({
              className:
                "border-solid border border-[#400167] rounded py-4 px-4 text-center cursor-pointer w-[683.89px]",
            })}
          >
            <input {...getInputPropsVideo()} />
            {video ? (
              <p>{video.name}</p>
            ) : (
              <div className="flex flex-col justify-center items-center">
                <SlCloudUpload size={20} className="text-[#9E9E9E]" />
                <p className="text-[14px] font-satoshi font-bold text-[#9E9E9E]">
                  Click to upload{" "}
                </p>
                <p className="font-satoshi font-[400] text-[12px] text-[#9E9E9E]">
                  (JPEG and PNG)
                </p>
              </div>
            )}
          </div>
        </div>
        <Link to="/lessons/topic-assessment">
          <button className="bg-[#5002D0] text-[16px] text-white font-satoshi font-bold py-5 px-4 rounded-full mt-4 w-[480px]">
            Continue to add assessment
          </button>
        </Link>
      </div>
    </div>
  );
};

export default AddTopicForm;
